import { Box } from "@mui/material"
import React, { useMemo } from "react"
import { useAppContext } from "../../app/Context"
import { Agent } from "../../types/Agent"

interface AgentVideoProps {
  agent: Agent
}

export function AgentVideo({ agent }: AgentVideoProps) {
  const { user } = useAppContext()

  const videoUrl = useMemo(() => {
    if (user) return agent?.avatar_video_url
    return
  }, [user, agent])

  return (
    <Box
      component="video"
      src={videoUrl}
      autoPlay
      muted
      loop
      playsInline
      sx={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center",
      }}
    />
  )
}
